import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { CreatedFormRelease } from '../../core';
import { Result } from '@digibricks/domains';
export var FormReleaseMapper = /*#__PURE__*/function () {
  function FormReleaseMapper() {
    _classCallCheck(this, FormReleaseMapper);
  }

  _createClass(FormReleaseMapper, [{
    key: "toDomain",
    value: function toDomain(input) {
      var id = input.id,
          version = input.version,
          totalScore = input.totalScore,
          totalQuestions = input.totalQuestions;
      var createFormReleaseResponseOrError = CreatedFormRelease.create({
        version: version,
        totalScore: totalScore,
        totalQuestions: totalQuestions
      }, id);

      if (createFormReleaseResponseOrError.isFailure) {
        return Result.fail(createFormReleaseResponseOrError.error);
      }

      return createFormReleaseResponseOrError;
    }
  }]);

  return FormReleaseMapper;
}();